module.exports = __webpack_public_path__ + "static/aerial-views-x-03e7d855f6c5c65af049960866a07a28.jpg";